import React, { useContext, useState } from "react";

const AppContext = React.createContext([{}, () => { }]);

export const UseAppContext = () => {
    return useContext(AppContext);
};

const AppContextProvider = (props) => {
    
    const sessionAuth = localStorage.getItem("TOKEN") ? true : false;

    const storedUser = localStorage.getItem("USER");

    const sessionUser = storedUser ? JSON.parse(storedUser) : {
        email: "",
        userId: "",
        userName: ""
    };

    const clientId = localStorage.getItem("CLIENT_ID") || "";

    const storedAppFeature = localStorage.getItem("APP_FEATURE");
    let appxFeature = {};
    if (storedAppFeature !== "undefined") {
        appxFeature = JSON.parse(storedAppFeature);
    }

    const storedNCount = localStorage.getItem("NOTIFICATION_COUNT");
    const nCount = storedNCount !== "undefined"? storedNCount : null;
   
    const appFeature = appxFeature;

    const [state, setState] = useState({
        user: sessionUser,
        auth: sessionAuth,
        reloadSummary: false,
        reload: {},
        clientId: clientId,
        appFeature: appFeature,
        notificationCount: nCount
    });
    return (
        <AppContext.Provider value={[state, setState]}>
            {props.children}
        </AppContext.Provider>
    );
};

export { AppContext, AppContextProvider };
